import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, call, sync } from 'vuex-pathify';
export default {
  name: 'UploadSurveys',
  components: {
    FibCommonModal: require("../../components/CommonModal").default
  },
  props: {
    value: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      showError: false,
      showSuccess: false,
      showWait: false,
      originalSurveyAmount: 0
    };
  },
  computed: {
    completedSurveys: get('responses/responsesTemp'),
    submittedSurveys: sync('responses/submittedSurveys')
  },
  watch: {
    value: function value(activated) {
      if (activated) {
        this.originalSurveyAmount = this.completedSurveys.length;
        this.uploadSurveys();
      }
    }
  },
  methods: {
    done: function done(result) {
      this.$emit('done', {
        name: 'upload',
        result: result
      });
      this.submittedSurveys = 0;
      this.$emit('input');
    },
    sendResponses: call('responses/sendResponses'),
    uploadSurveys: function uploadSurveys() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var ok;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Logger.debug('Upload completed surveys');
                _this.showWait = true;
                _context.next = 4;
                return _this.sendResponses();

              case 4:
                ok = _context.sent;
                _this.showWait = false;

                _this.$store.commit('responses/resetCurrent');

                if (ok) {
                  _this.showSuccess = true;
                } else {
                  _this.showError = true;
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};